export function compareIssuingPolicy(idTokenClaims: any, policyToCompare: any) {
  let tfpMatches = idTokenClaims['tfp'] === policyToCompare.toLowerCase();
  let acrMatches = idTokenClaims['acr'] === policyToCompare.toLowerCase();
  return tfpMatches || acrMatches;
}
